import React from "react";
import Image from "../../../assets/img/About-Images/TAS.jpg";
import "./azca-story.scss";
import { Fade } from "react-reveal";
import useFetch from "../../../Hooks/useFetch";

export default function AzcaStory() {
  const { data } = useFetch();
  const myField = data?.items.find((item, index) => {
    if (item.sys.id === "1VpU31BISPlAMHez6ODkDz") {
      return item;
    }
  });

  // console.log(myField?.fields)
  // console.log(data?.Azcastory.card.title)
  return (
    <div id="azca-story">
      <img src={myField?.fields.asImg.fields.file.url} alt="To new begining" />
      <Fade right>
        <div className="dark-card">
          <div>
            <h2>{myField?.fields.asTitle}</h2>
            <p>{myField?.fields.asParagraph}</p>
          </div>
        </div>
      </Fade>
    </div>
  );
}
